import { render, staticRenderFns } from "./BlockConnectors.vue?vue&type=template&id=00fcb439"
import script from "./BlockConnectors.vue?vue&type=script&lang=js"
export * from "./BlockConnectors.vue?vue&type=script&lang=js"
import style0 from "./BlockConnectors.vue?vue&type=style&index=0&id=00fcb439&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports